import i18next from 'i18next'
import { indexToDateChunk } from 'utils'

export const PERSON_DOB_API_FORMAT = 'YYYY-MM-DD'
export const PERSON_DOB_UI_FORMAT = 'DD MMM YYYY'

const currentYear = new Date().getFullYear()
const maxYearSpan = 100
const monthsIndices = Array.from(Array(12).keys())
const daysIndices = Array.from(Array(31).keys())
const yearsIndices = Array.from(Array(maxYearSpan).keys())

export const MONTHS = monthsIndices.map(i => indexToDateChunk(i))
export const DAYS = daysIndices.map(i => indexToDateChunk(i))
export const YEARS = yearsIndices.map(i => `${currentYear - i}`)

export const DAY_OPTIONS = DAYS.map((day, i) => ({
  value: day,
  label: `${Number(day)}`,
}))

export const MONTH_OPTIONS = MONTHS.map((month, i) => ({
  value: month,
  get label() {
    try {
      const monthsShort = i18next.t('monthsShort', {
        ns: 'strDates',
        returnObjects: true,
      }) as string[]
      return Array.isArray(monthsShort) && monthsShort[i] ? monthsShort[i] : `${i + 1}`
    } catch (e) {
      return `${i + 1}`
    }
  },
}))

export const YEAR_OPTIONS = YEARS.map((year, i) => ({
  value: `${year}`,
  label: `${year}`,
}))
